import { render, staticRenderFns } from "./RootLanding.vue?vue&type=template&id=27b6b305&scoped=true"
import script from "./RootLanding.vue?vue&type=script&lang=js"
export * from "./RootLanding.vue?vue&type=script&lang=js"
import style0 from "./RootLanding.vue?vue&type=style&index=0&id=27b6b305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6b305",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
